import React, { useState } from "react";
import { collection, getDocs, query, where } from "firebase/firestore";
import { custDb } from "../../../firebaseCust";
import Papa from "papaparse";

export default function OrderExport() {

  const [storeCode, setStoreCode] = useState("");
  const [status, setStatus] = useState("all");
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchOrders = async () => {
    if (!storeCode) {
      alert("Enter Store Code");
      return;
    }

    setLoading(true);

    try {
      const ordersRef = collection(custDb, "customers", storeCode, "orders");

      let q = ordersRef;

      if (status !== "all") {
        q = query(ordersRef, where("status", "==", status));
      }

      const snapshot = await getDocs(q);

      const data = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
      }));

      setOrders(data);

    } catch (err) {
      console.error(err);
      alert("Error loading orders");
    }

    setLoading(false);
  };

  const exportToCSV = () => {
    if (orders.length === 0) {
      alert("No orders to export");
      return;
    }

    const exportData = orders.map(order => ({
      OrderID: order.id,
      Customer: order.customerName,
      Email: order.email,
      Total: order.total,
      Status: order.status,
      Items: order.items
        ?.map(i => `${i.name} x${i.qty}`)
        .join(" | "),
      Date: order.createdAt?.toDate
        ? order.createdAt.toDate().toLocaleString()
        : ""
    }));

    const csv = Papa.unparse(exportData);

    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = `${storeCode}_orders.csv`;
    link.click();
  };

  return (
    <div style={{ padding: "30px", background: "#fff", borderRadius: "12px", maxWidth: "800px" }}>

      <h2 className="text-2xl font-bold mb-6">Customer Order Export</h2>

      <label>Store Code</label>
      <input
        value={storeCode}
        onChange={e => setStoreCode(e.target.value)}
        className="border p-2 w-full mb-4"
        placeholder="ex: wearwonder"
      />

      <label>Status</label>
      <select
        value={status}
        onChange={e => setStatus(e.target.value)}
        className="border p-2 w-full mb-6"
      >
        <option value="all">All Orders</option>
        <option value="pending">Pending</option>
        <option value="paid">Paid</option>
        <option value="shipped">Shipped</option>
        <option value="canceled">Canceled</option>
      </select>

      <button
        onClick={fetchOrders}
        className="bg-black text-white py-2 px-6 w-full mb-4"
      >
        {loading ? "Loading..." : "LOAD ORDERS"}
      </button>

      {orders.length > 0 && (
        <>
          <p className="mb-4">✅ {orders.length} orders found</p>

          <button
            onClick={exportToCSV}
            className="bg-green-600 text-white py-2 px-6 w-full"
          >
            DOWNLOAD CSV
          </button>

          <div className="max-h-64 overflow-auto border mt-6 p-2 text-sm">
            {orders.map(o => (
              <div key={o.id} className="border-b py-2">
                <strong>{o.customerName}</strong> - ${o.total} - {o.status}
              </div>
            ))}
          </div>
        </>
      )}

    </div>
  );
}
